<template>
  <div class="MapDialogue" @click="toggleMap();">

    <!-- Generic Content --> 
    <div class="md-container-generic" v-if="mapStyle=='generic'">
      <SituationCard class="md-card" v-for="s in situations" :key="s.id" :situationID="s.id"/>  
    </div>

    <!-- Specific Content -->
    <div v-else id="map" class="md-container-specific" :class="mapStyle+'Container'" @touchstart="onTouchStart" @touchmove="onTouchMove" @touchend="endMapMove" @click="$event.stopPropagation()">
      <img :src="'./Maps/'+mapStyle+'.png'" alt="">
      <SituationPin class="md-sp" v-for="(s, i) in sortedSituations" :key="s.id" :class="mapStyle.substr(0,3)+i" :situationID="s.id"/> 
    </div>
      
  </div>
</template>
  
<style scoped>
  .MapDialogue{
    width: 100%;
    height: 100%; 
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
    background: #000000d0;
  }

  /* Generic Content */
  .md-container-generic {
    width: 80%;
    height: 80%;
    text-align: center;
    overflow-y: auto;
    background: rgba(48, 47, 47, 0.78);
    border-radius: 10px;
  }
  .md-card{
    margin: 20px;
  }

  /* Specific Content */
  .md-container-specific {
    position: relative;
  }
  .md-sp{
    position: absolute;
  }
 
  /* Scrollbar CSS */
  ::-webkit-scrollbar{
    height: 13px;
  }
  ::-webkit-scrollbar-track{
    background: rgb(49, 49, 49);
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb{
    border-radius:10px;
    border: 1px solid rgb(27, 27, 27);
    background: rgb(111,111,111);
  }

  /* Map sizes */
  .MuseumTourContainer {width: 75%;}
  .VigourMessestandContainer {width: 45%;}
  .CosmoMessestandContainer {width: 60%;}
  .DMGMoriContainer {width: 55%;}
  .VjTechnikumContainer {width: 70%;}
  .VenjakobAeroContainer {width: 50%;}
  .HFGroupContainer {width: 55%; margin-top: 70px;}

  /* Map size small Display */
  @media (max-width: 1600px) { 
    .md-container-specific {width: 750px;}
    .MuseumTourContainer {width: 950px;}
    .VigourMessestandContainer {width: 700px;}
    .CosmoMessestandContainer {width: 850px;}
    .DMGMoriContainer {width: 750px;}
    .VjTechnikumContainer {width: 80%;}
    .VenjakobAeroContainer {width: 750px;}
    .HFGroupContainer {width: 750px;}
  }
  /* Map size Mobile */
 @media (max-device-width: 900px){
    .md-container-specific {width: 90%;}
    @media (orientation:landscape){
       .md-container-specific {width: 50%;}
    }
  }

/* Specific Pins*/

/* Pin Position Museum Test Tour  */
  .Mus0 {left: 60%;top: 75%;}
  .Mus1 {left: 45%;top: 20%;}
  .Mus2 {left: 17%;top: 75%;}

/* Pin Position Vigour Tour  */
  .Vig0 {left: 55%;top: 85%;}
  .Vig1 {left: 38%;top: 75%;}
  .Vig2 {left: 58%;top: 75%;}
  .Vig3 {left: 15%;top: 75%;}
  .Vig4 {left: 30%;top: 45%;}
  .Vig5 {left: 15%;top: 40%;}
  .Vig6 {left: 40%;top: 55%;}
  .Vig7 {left: 17%;top: 25%;}  
  .Vig8 {left: 38%;top: 35%;}  
  .Vig9 {left: 58%;top: 35%;}  
  .Vig10 {left: 48%;top: 45%;}  
  .Vig11 {left: 48%;top: 30%;}  
  .Vig12 {left: 80%;top: 35%;}  
  .Vig13 {left: 65%;top: 43%;}  
  .Vig14 {left: 61%;top: 61%;}  
  .Vig15 {left: 73%;top: 55%;}  
  .Vig16 {left: 65%;top: 66%;}  
  .Vig17 {left: 61%;top: 48%;}  
  .Vig18 {left: 57%;top: 55%;}  
  .Vig19 {left: 80%;top: 75%;}  
  .Vig20 {left: 65%;top: 90%;}  
  .Vig21 {left: 45%;top: 20%;}  
  .Vig22 {left: 10%;top: 55%;}  
  .Vig23 {left: 85%;top: 55%;}  
  .Vig24 {left: 48%;top: 90%;}  
  .Vig25 {left: 35%;top: 85%;}  
  .Vig26 {left: 48%;top: 80%;}  
  
/* Pin Position Cosmo Tour  */
  .Cos0 {left: 48%;top: 55%;}
  .Cos1 {left: 48%;top: 48%;}
  .Cos2 {left: 26%;top: 65%;}
  .Cos3 {left: 26%;top: 72%;}
  .Cos4 {left: 36%;top: 70%;}
  .Cos5 {left: 36%;top: 77%;}
  .Cos6 {left: 90%;top: 75%;}
  .Cos7 {left: 90%;top: 68%;}
  .Cos8 {left: 85%;top: 48%;}  
  .Cos9 {left: 92%;top: 48%;}  
  .Cos10 {left: 78%;top: 48%;}  
  .Cos11 {left: 78%;top: 41%;}  
  .Cos12 {left: 71%;top: 48%;}  
  .Cos13 {left: 90%;top: 26%;}  
  .Cos14 {left: 90%;top: 19%;}  
  .Cos15 {left: 90%;top: 12%;}  
  .Cos16 {left: 90%;top: 5%;}  
  .Cos17 {left: 5%;top: 68%;}  
  .Cos18 {left: 5%;top: 75%;}  
  .Cos19 {left: 5%;top: 82%;}  
  .Cos20 {left: 5%;top: 26%;}  
  .Cos21 {left: 5%;top: 19%;}  
  .Cos22 {left: 5%;top: 12%;}  
  .Cos23 {left: 48%;top: 41%;}  
  .Cos24 {left: 26%;top: 79%;}  
  .Cos25 {left: 36%;top: 84%;}  
  .Cos26 {left: 90%;top: 61%;}  
  .Cos27 {left: 90%;top: 33%;}  
  .Cos28 {left: 5%;top: 89%;}  
  .Cos29 {left: 5%;top: 5%;}  
  .Cos30 {left: 48%;top: 62%;}  
  .Cos31 {left: 90%;top: 89%;}  
  .Cos32 {left: 90%;top: 82%;}  
  .Cos33 {left: 26%;top: 57%;}  

/* Pin Position Venjakob Aero Tour  */
  .Ven0 {left: 50%;top: 90%;}
  .Ven1 {left: 5%;top: 50%;}
  .Ven2 {left: 50%;top: 5%;}
  .Ven3 {left: 90%;top: 50%;}

/* Pin Position Venjakob Technikum Tour  */
  .VjT0 {left: 63%;top: 81%;}
  .VjT1 {left: 41%;top: 81%;}
  .VjT2 {left: 27%;top: 60%;}
  .VjT3 {left: 33.5%;top: 50%;}
  .VjT4 {left: 41%;top: 60%;}
  .VjT5 {left: 53%;top: 32%;}
  .VjT6 {left: 74%;top: 32%;}
  .VjT7 {left: 74%;top: 50%;}
  .VjT8 {left: 74%;top: 70%;}
  .VjT9 {left: 57%;top: 65%;}
  .VjT10 {left: 66%;top: 65%;}

/* Pin Position DMG Mori Tour  */
  .DMG0 {left: 70%;top: 25%;}
  .DMG1 {left: 25%;top: 80%;}
  .DMG2 {left: 25%;top: 25%;}
  .DMG3 {left: 70%;top: 80%;}
  .DMG4 {left: 50%;top: 50%;}

/* Pin Position HF Group Tour  */
  .HFG0 {left: 94.5%;top: 90%;}
  .HFG1 {left: 83%;top: 85%;}
  .HFG2 {left: 80%;top: 67%;}
  .HFG3 {left: 73%;top: 67%;}
  .HFG4 {left: 38%;top: 63%;}
  .HFG5 {left: 34%;top: 53%;}
  .HFG6 {left: 34%;top: 41%;}
  .HFG7 {left: 34%;top: 28%;}
  .HFG9 {left: 45%;top: 48%;}
  .HFG8 {left: 45%;top: 32%;}
  .HFG10 {left: 10%;top: 63%;}
  .HFG11 {left: 15%;top: 52%;}
  .HFG12 {left: 15%;top: 41%;}
  .HFG13 {left: 15%;top: 30%;}
  .HFG14 {left: 15%;top: 19%;}
  .HFG15 {left: 11%;top: 80%;}
  .HFG16 {left: 70%;top: 15%;}

</style>

<script>
import {mapGetters,mapMutations} from 'vuex';
import SituationPin from '@/components/flux360/SituationPin'
import SituationCard from '@/components/flux360/SituationCard'

export default {
    components: {SituationPin, SituationCard},
    inject: ['toggleMap'],
	data: () => ({
    scaleMapEnabled: false,
    moveMapEnabled: false,
    originalScale: 0,
    originalInputPositionX: 0,
    originalInputPositionY: 0,
    originalMapPositionX: 0,
    originalMapPositionY: 0,
    originalDist: 0,
    removeSituations: ["Tire Building 2","Tire Building 3","Tire Building 4","Tire Building - Top View","HF Mixing Group - Technical Center 2","HF Mixing Group - Technical Center 3",
    "HF Mixing Group - Technical Center 4","Curemaster - Truck Press - Left","Curemaster - Truck Press - Right","Curemaster - Truck Press - Back","Curemaster - Truck Press - Top View"]
	}),
	computed: {
    ...mapGetters(['situations','panoramaTour']),
    sortedSituations(){
      if(this.panoramaTour){
        if(this.panoramaTour.getName() == "HF Group"){
            let newSituations = [];

            this.situations.forEach(e1 => {
              let addToSituation = true;
              this.removeSituations.forEach(e2 => {
                if(e1.getName().trim() == e2)
                  addToSituation = false;  
              });
              if(addToSituation)
                newSituations.push(e1);
            });

            return newSituations;
        }
      }

      // default: return unsorted situations
      return this.situations;
    },

    mapStyle(){
      if(this.panoramaTour){
        console.log("Checking if a dedicated map for tour " + this.panoramaTour.getID() + ": " + this.panoramaTour.getName() + " is available" );
        switch(this.panoramaTour.getID()) {
          case 123885: return "MuseumTour";
          case 129085: return "MuseumTour";
          case 103280: return "VigourMessestand";        
          case 96359:  return "CosmoMessestand"
          case 133616: return "VenjakobAero";
          case 135630: return "DMGMori";
          case 136793: return "VjTechnikum";
          case 173806: return "HFGroup";
        }
      }
      return "generic";
    }
	},
	methods: {
    // Functions for touch Zoom
    moveMap(x,y){
      let left = (x - this.originalInputPositionX) + this.originalMapPositionX;
      let top = (y - this.originalInputPositionY) + this.originalMapPositionY;
      document.getElementById("map").style.left = left+"px";
      document.getElementById("map").style.top = top+"px";
    },
    zoomMap(e){
      let dist = Math.hypot(e.touches[0].pageX - e.touches[1].pageX,e.touches[0].pageY - e.touches[1].pageY) / this.originalDist ;
      document.getElementById("map").style.width = (this.originalScale*dist)+"px";
    },
    startMapZoom(e){
      this.scaleMapEnabled = true;    
      this.originalDist = Math.hypot(e.touches[0].pageX - e.touches[1].pageX,e.touches[0].pageY - e.touches[1].pageY);
      this.originalScale = parseInt(getComputedStyle(document.getElementById("map")).width);
    },
    startMapMove(x,y){
      this.moveMapEnabled = true;    
      this.originalInputPositionX = x; 
      this.originalInputPositionY = y;
      this.originalMapPositionX = parseInt(getComputedStyle(document.getElementById("map")).left);
      this.originalMapPositionY = parseInt(getComputedStyle(document.getElementById("map")).top);
    },
    endMapMove(){
      this.scaleMapEnabled = false;   
      this.moveMapEnabled = false; 
    },
    onTouchStart(e){
      if (e.touches.length === 2)
        this.startMapZoom(e);      
      if(e.touches.length === 1) 
        this.startMapMove(e.touches[0].pageX,e.touches[0].pageY);          
    },
    onTouchMove(e){
      if(this.scaleMapEnabled)
        this.zoomMap(e);      
      if(this.moveMapEnabled)
        this.moveMap(e.touches[0].pageX,e.touches[0].pageY);   
    },
	},
}
</script>

